import { render, staticRenderFns } from "./chakan-c.vue?vue&type=template&id=4b7861ac&scoped=true"
import script from "./chakan-c.vue?vue&type=script&lang=js"
export * from "./chakan-c.vue?vue&type=script&lang=js"
import style0 from "./chakan-c.vue?vue&type=style&index=0&id=4b7861ac&prod&lang=less&scoped=true"
import style1 from "./chakan-c.vue?vue&type=style&index=1&id=4b7861ac&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7861ac",
  null
  
)

export default component.exports